import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Button = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 4px;
    border: solid 1px #f1f1ee;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 1);

    &:hover {
        ${props =>
            props.hoverColor
                ? 'background-color: ' + props.hoverColor
                : 'background-color: #ff245e'};

        path {
            fill: white;
        }
    }
`;

const ShareButton = props => (
    <Button hoverColor={props.hoverColor} onClick={props.handleClick}>
        {props.children}
    </Button>
);

ShareButton.propTypes = {
    children: PropTypes.object.isRequired,
    hoverColor: PropTypes.string,
    handleClick: PropTypes.func
};

export default ShareButton;
